import { render, staticRenderFns } from "./RiskProfileResults.vue?vue&type=template&id=0fde5e8a&"
import script from "./RiskProfileResults.vue?vue&type=script&lang=ts&"
export * from "./RiskProfileResults.vue?vue&type=script&lang=ts&"
import style0 from "./RiskProfileResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports